<template>
  <div>
    <router-link to="/" class="btn top-right back-to-results" tag="button"
      >Return To FindAR</router-link
    >
    <span v-for="(category, index) in topics" :key="index">
      <button class="accordion">
        <div>
        {{ category.term }}
        </div>
        <div> &#9660;
        </div>
      </button>
      <div class="panel">
        <h5>Search terms within this category:</h5>
        <span class="tagsList">
          <li v-for="(tag, index) in category.lowLevel" :key="index">
            <a
              @click="setMetaData(category.term, tag)"
              class="button tag-list"
              >{{ tag }}</a
            >
          </li>
        </span>
      </div>
    </span>
  </div>
</template>
<script>
import topics from "@/assets/topics.json";
import { store } from "@/store";
export default {
  data() {
    return {
      topics,
      store
    };
  },
  methods: {
    setMetaData(midLevel, lowLevel) {
      this.store.state.lowLevelTerm = lowLevel;
      this.store.state.midLevelTerm = midLevel;
      this.store.getFilteredArticles();
      this.store.state.showResultsTable = true;
      this.$router.push("/");
    }
  },
  mounted() {
    //Initialze our accordian
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
       
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
    if (document.querySelector("#page .container h1.title").textContent)
      document.querySelector("#page .container h1.title").innerHTML =
        "<a href = '/search-tool/'>FindAR</a>";
  }
};
</script>
<style>
.accordion {
  display: flex;
  justify-content: space-between;
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
  text-transform: capitalize;
}

.active,
.accordion:hover {
  background-color: #ccc;
}

.panel {
  padding: 0 18px;
  display: none;
  background-color: white;
  overflow: hidden;
}

.button.tag-list {
  background: #eee;
  color: black;
  font-weight: bold;
  margin-right: 10px;
  margin: 10px;
  padding: 10px;
  height: 10px;
  text-decoration: none;
  text-transform: capitalize;
  cursor: pointer;
}
.button.tag-list:hover {
  background: white;
  color: #0a3a4a;
}

.tagsList {
  display: flex;
  flex-wrap: wrap;
}
.tagsList li {
 padding-top: 20px;
 padding-bottom: 20px;
  list-style: none
}



</style>
